/* tslint:disable */
import {
  CompanyAccount,
  ChartOfAccount,
  WorkOrder,
  PropertySettlement
} from '../index';

declare var Object: any;
export interface WorkOrderExpensesInterface {
  "management_company_id"?: number;
  "quantity"?: string;
  "price"?: string;
  "amount": number;
  "witholding_tax_amount": number;
  "date_incurred": Date;
  "due_date"?: Date;
  "payment_status": string;
  "description"?: string;
  "property_id": number;
  "date_paid"?: Date;
  "tag"?: string;
  "doc_status"?: string;
  "item_type"?: string;
  "property_settlement_id"?: number;
  "cancelled"?: boolean;
  "id"?: number;
  "chart_of_account_id"?: number;
  "work_order_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  property?: CompanyAccount;
  chartOfAccount?: ChartOfAccount;
  workOrder?: WorkOrder;
  propertySettlement?: PropertySettlement;
}

export class WorkOrderExpenses implements WorkOrderExpensesInterface {
  "management_company_id": number;
  "quantity": string;
  "price": string;
  "amount": number;
  "witholding_tax_amount": number;
  "date_incurred": Date;
  "due_date": Date;
  "payment_status": string;
  "description": string;
  "property_id": number;
  "date_paid": Date;
  "tag": string;
  "doc_status": string;
  "item_type": string;
  "property_settlement_id": number;
  "cancelled": boolean;
  "id": number;
  "chart_of_account_id": number;
  "work_order_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  property: CompanyAccount;
  chartOfAccount: ChartOfAccount;
  workOrder: WorkOrder;
  propertySettlement: PropertySettlement;
  constructor(data?: WorkOrderExpensesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `WorkOrderExpenses`.
   */
  public static getModelName() {
    return "WorkOrderExpenses";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of WorkOrderExpenses for dynamic purposes.
  **/
  public static factory(data: WorkOrderExpensesInterface): WorkOrderExpenses{
    return new WorkOrderExpenses(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'WorkOrderExpenses',
      plural: 'WorkOrderExpenses',
      path: 'WorkOrderExpenses',
      idName: 'id',
      properties: {
        "management_company_id": {
          name: 'management_company_id',
          type: 'number'
        },
        "quantity": {
          name: 'quantity',
          type: 'string'
        },
        "price": {
          name: 'price',
          type: 'string'
        },
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "witholding_tax_amount": {
          name: 'witholding_tax_amount',
          type: 'number',
          default: 0
        },
        "date_incurred": {
          name: 'date_incurred',
          type: 'Date'
        },
        "due_date": {
          name: 'due_date',
          type: 'Date'
        },
        "payment_status": {
          name: 'payment_status',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "date_paid": {
          name: 'date_paid',
          type: 'Date'
        },
        "tag": {
          name: 'tag',
          type: 'string'
        },
        "doc_status": {
          name: 'doc_status',
          type: 'string'
        },
        "item_type": {
          name: 'item_type',
          type: 'string'
        },
        "property_settlement_id": {
          name: 'property_settlement_id',
          type: 'number'
        },
        "cancelled": {
          name: 'cancelled',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "work_order_id": {
          name: 'work_order_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chart_of_account_id',
          keyTo: 'id'
        },
        workOrder: {
          name: 'workOrder',
          type: 'WorkOrder',
          model: 'WorkOrder',
          relationType: 'belongsTo',
                  keyFrom: 'work_order_id',
          keyTo: 'id'
        },
        propertySettlement: {
          name: 'propertySettlement',
          type: 'PropertySettlement',
          model: 'PropertySettlement',
          relationType: 'belongsTo',
                  keyFrom: 'property_settlement_id',
          keyTo: 'id'
        },
      }
    }
  }
}
